var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"padding":"0"}},[_c('video-component',{attrs:{"options":{
        url: _vm.videoUrl,
        type: 'application/x-mpegURL',
        subtitle: _vm.subtitleUrl,
      }},on:{"complete":function($event){return _vm.navigateToNextScreen()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }